import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SelectionChips from '@alltrails/denali/components/SelectionChips';
import styles from './ChipsFilterControl.module.scss';
import type { ChipsFilterConfigV2 } from './types';

const ChipsFilterControl = ({ filterConfig }: { filterConfig: ChipsFilterConfigV2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { collapsedChipCount, selectionChips } = filterConfig;
  const { chips } = selectionChips;

  const canExpand = !!collapsedChipCount && chips.length > collapsedChipCount;
  const visibleChips = canExpand && !isExpanded ? chips.slice(0, collapsedChipCount) : chips;

  return (
    <div>
      <SelectionChips {...selectionChips} chips={visibleChips} />
      {canExpand && (
        <button className={styles.moreChip} onClick={() => setIsExpanded(prev => !prev)}>
          {isExpanded ? <FormattedMessage defaultMessage="Less" /> : <FormattedMessage defaultMessage="More" />}
        </button>
      )}
    </div>
  );
};

export default ChipsFilterControl;
